import { ColorsType } from '../types'

const choices = {
    transparent: 'transparent',
    black: '#000',
    white: '#fff',
    perthNowRed: '#d42626',
    greyCoal: '#252525',
    greyMoonstone: '#777',
    greyStone: '#999',
    greyMarble: '#ccc',
    greyPyrite: '#e5e5e5',
    greyGlass: '#f3f3f3',
    greyBasalt: '#1b262e',
    greySlate: '#32373b',
    greyFlint: '#3c525c',
    greyShale: '#8798a1',
    greyPebble: '#97a5ad',
    blueKyanite: '#066cb6',
    pinkThulite: '#dd1466',
    greenTourmaline: '#38674',
    blueCerulean: '#009FDA',
    orangeCitrine: '#c74705',
    purpleAmethyst: '#a762a6',
    tealTopaz: '#0b8478',
    greenJade: '#418702',
}

export const colors: ColorsType = {
    brand: choices.perthNowRed,
    section: choices.white,
    background: choices.white,
    text: {
        primary: {
            default: choices.greyCoal,
            onDark: choices.white,
        },
        secondary: {
            default: choices.greyMoonstone,
            onDark: choices.white,
        },
        heading: {
            default: choices.greyCoal,
            onDark: choices.white,
        },
    },
    actions: {
        link: {
            default: choices.greyCoal,
            hover: choices.blueKyanite,
            focus: choices.blueKyanite,
            active: choices.blueKyanite,
            onDark: {
                default: choices.white,
                hover: choices.white,
                focus: choices.white,
                background: choices.blueKyanite,
                active: choices.white,
            },
        },
        button: {
            text: {
                default: choices.white,
                hover: choices.white,
                focus: choices.white,
                active: choices.white,
                onDark: {
                    default: choices.white,
                    hover: choices.white,
                    focus: choices.white,
                    active: choices.white,
                },
            },
            background: {
                default: choices.pinkThulite,
                hover: choices.blueKyanite,
                focus: choices.blueKyanite,
                active: choices.blueKyanite,
                onDark: {
                    default: choices.greyCoal,
                    hover: choices.pinkThulite,
                    focus: choices.pinkThulite,
                    active: choices.pinkThulite,
                },
            },
            border: {
                default: choices.white,
                onDark: choices.white,
            },
        },
    },
}
